import {
  BarChart3,
  BookOpen,
  Calendar,
  ClipboardList,
  ChevronDown,
  ChevronRight,
  GraduationCap,
  Home,
  Mail,
  MessageSquare,
  PanelsTopLeft,
  Settings,
  UserRoundCog,
  Users,
  Wallet,
} from 'lucide-react';
import { PERMISSIONS } from '../../utils/permissions';

const academicsChildren = [
  { label: 'Courses', path: '/dashboard/courses', permission: PERMISSIONS.COURSES_READ },
  { label: 'Intakes', path: '/dashboard/intakes', permission: PERMISSIONS.INTAKES_READ },
  { label: 'Classes', path: '/dashboard/classes', permission: PERMISSIONS.CLASSES_READ },
];

const studentChildren = [
  { label: 'Active students', path: '/dashboard/students/active', permission: PERMISSIONS.STUDENTS_READ },
  { label: 'Learning breaks', path: '/dashboard/students/learning-breaks', permission: PERMISSIONS.STUDENTS_READ },
  { label: 'Graduated students', path: '/dashboard/students/graduated', permission: PERMISSIONS.STUDENTS_READ },
  { label: 'Never joined', path: '/dashboard/students/never-joined', permission: PERMISSIONS.STUDENTS_READ },
  { label: 'Dropped students', path: '/dashboard/students/other', permission: PERMISSIONS.STUDENTS_READ },
];

const analyticsChildren = [
  { label: 'Active Students with Cleared Fees', path: '/dashboard/analytics/active-students-cleared-fees', permission: PERMISSIONS.DASHBOARD_READ },
  { label: 'Active Students with Uncleared Fees', path: '/dashboard/analytics/active-students-uncleared-fees', permission: PERMISSIONS.DASHBOARD_READ },
  { label: 'Active Students Paying Fees', path: '/dashboard/analytics/active-students-paying-fees', permission: PERMISSIONS.DASHBOARD_READ },
  { label: 'Active Students Not Paying Fees', path: '/dashboard/analytics/active-students-not-paying-fees', permission: PERMISSIONS.DASHBOARD_READ },
  { label: 'Fee Collection Standing', path: '/dashboard/analytics/fee-collection-standing', permission: PERMISSIONS.DASHBOARD_READ },
  { label: 'Active Attendance Students', path: '/dashboard/analytics/active-attendance-students', permission: PERMISSIONS.DASHBOARD_READ },
  { label: 'Inactive Attendance Students', path: '/dashboard/analytics/inactive-attendance-students', permission: PERMISSIONS.DASHBOARD_READ },
  { label: 'Daily Attendance Register', path: '/dashboard/analytics/daily-attendance-register', permission: PERMISSIONS.DASHBOARD_READ },
  { label: 'Intake Success Trend', path: '/dashboard/analytics/intake-success-trend', permission: PERMISSIONS.DASHBOARD_READ },
  { label: 'Sources of Students', path: '/dashboard/analytics/sources-of-students', permission: PERMISSIONS.DASHBOARD_READ },
  { label: 'Conversion by Source', path: '/dashboard/analytics/conversion-by-source', permission: PERMISSIONS.DASHBOARD_READ },
  { label: 'Trends Over Time', path: '/dashboard/analytics/trends-over-time', permission: PERMISSIONS.DASHBOARD_READ },
  { label: 'Course Performance by Source', path: '/dashboard/analytics/course-performance-by-source', permission: PERMISSIONS.DASHBOARD_READ },
  { label: 'Demographics by Source', path: '/dashboard/analytics/demographics-by-source', permission: PERMISSIONS.DASHBOARD_READ },
  { label: 'Campus Type Distribution', path: '/dashboard/analytics/campus-type-distribution', permission: PERMISSIONS.DASHBOARD_READ },
  { label: 'Drop-off Analysis', path: '/dashboard/analytics/drop-off-analysis', permission: PERMISSIONS.DASHBOARD_READ },
  { label: 'Application to Admission Time', path: '/dashboard/analytics/application-to-admission-time', permission: PERMISSIONS.DASHBOARD_READ },
  { label: 'Session Time Demand', path: '/dashboard/analytics/session-time-demand', permission: PERMISSIONS.DASHBOARD_READ },
  { label: 'Distribution by Country', path: '/dashboard/analytics/distribution-by-country', permission: PERMISSIONS.DASHBOARD_READ },
  { label: 'Nationality vs Course Choice', path: '/dashboard/analytics/nationality-vs-course-choice', permission: PERMISSIONS.DASHBOARD_READ },
];

const communicationChildren = [
  { label: 'SMS', path: '/dashboard/communication/sms', permission: PERMISSIONS.DASHBOARD_READ },
  { label: 'WhatsApp', path: '/dashboard/communication/whatsapp', permission: PERMISSIONS.DASHBOARD_READ },
  { label: 'Email', path: '/dashboard/communication/email', permission: PERMISSIONS.DASHBOARD_READ },
];

const financeChildren = [
  { label: 'School Fee Income', path: '/dashboard/finance/school-fee-income', permission: PERMISSIONS.FINANCE_READ },
  { label: 'Invoices', path: '/dashboard/finance/invoices', permission: PERMISSIONS.FINANCE_READ },
  { label: 'Fee Balances', path: '/dashboard/finance/fee-balances', permission: PERMISSIONS.FINANCE_READ },
];

const hrChildren = [
  { label: 'Employees', path: '/dashboard/hr/employees', permission: PERMISSIONS.TEAM_READ },
  { label: 'Pay Salaries', path: '/dashboard/hr/payroll/pay-salaries', permission: PERMISSIONS.TEAM_READ },
  { label: 'Payment Ledger', path: '/dashboard/hr/payroll/payment-ledger', permission: PERMISSIONS.TEAM_READ },
];

const privateInstructorHrChildren = [
  { label: 'Employees', path: '/dashboard/hr/employees', permission: PERMISSIONS.DASHBOARD_READ },
  { label: 'Pay Salaries', path: '/dashboard/hr/payroll/pay-salaries', permission: PERMISSIONS.DASHBOARD_READ },
  { label: 'Payment Ledger', path: '/dashboard/hr/payroll/payment-ledger', permission: PERMISSIONS.DASHBOARD_READ },
];

export const schoolDashboardNavigation = [
  { label: 'Dashboard', path: '/dashboard', icon: Home, permission: PERMISSIONS.DASHBOARD_READ, end: true },
  { label: 'Applications', path: '/dashboard/applications', icon: ClipboardList, permission: PERMISSIONS.INTAKES_READ },
  { label: 'Academics', path: '/dashboard/academics', icon: GraduationCap, permission: PERMISSIONS.COURSES_READ, children: academicsChildren },
  { label: 'Students', path: '/dashboard/students', icon: Users, permission: PERMISSIONS.STUDENTS_READ, children: studentChildren },
  { label: 'Data Analytics', path: '/dashboard/analytics', icon: BarChart3, permission: PERMISSIONS.DASHBOARD_READ, children: analyticsChildren },
  { label: 'Communication', path: '/dashboard/communication', icon: MessageSquare, permission: PERMISSIONS.DASHBOARD_READ, children: communicationChildren },
  { label: 'Finance', path: '/dashboard/finance', icon: Wallet, permission: PERMISSIONS.FINANCE_READ, children: financeChildren },
  { label: 'HR', path: '/dashboard/hr', icon: UserRoundCog, permission: PERMISSIONS.TEAM_READ, children: hrChildren },
  { label: 'Site Builder', path: '/dashboard/site-builder', icon: PanelsTopLeft, permission: PERMISSIONS.SETTINGS_READ },
  { label: 'Settings', path: '/dashboard/settings', icon: Settings, permission: PERMISSIONS.SETTINGS_READ },
];

export const privateInstructorNavigation = [
  { label: 'Dashboard', path: '/dashboard', icon: Home, permission: PERMISSIONS.DASHBOARD_READ, end: true },
  { label: 'Courses', path: '/dashboard/courses', icon: BookOpen, permission: PERMISSIONS.COURSES_READ },
  { label: 'Classes', path: '/dashboard/classes', icon: Calendar, permission: PERMISSIONS.CLASSES_READ },
  { label: 'Students', path: '/dashboard/students', icon: Users, permission: PERMISSIONS.STUDENTS_READ },
  { label: 'Finance', path: '/dashboard/finance', icon: Wallet, permission: PERMISSIONS.FINANCE_READ },
  { label: 'HR', path: '/dashboard/hr', icon: UserRoundCog, permission: PERMISSIONS.DASHBOARD_READ, children: privateInstructorHrChildren },
  { label: 'Site Builder', path: '/dashboard/site-builder', icon: PanelsTopLeft, permission: PERMISSIONS.SETTINGS_READ },
  { label: 'Settings', path: '/dashboard/settings', icon: Settings, permission: PERMISSIONS.SETTINGS_READ },
];

export const dashboardNavigation = schoolDashboardNavigation;

export function getDashboardNavigation() {
  // Keep the complete dashboard navigation available while account-type
  // restrictions are being finalized.
  return schoolDashboardNavigation;
}

export function filterNavigation(items = [], can, options = {}) {
  const { hideTeam = false } = options;

  return items.reduce((acc, item) => {
    if (hideTeam && item.path === '/dashboard/team') return acc;

    if (item.children?.length) {
      const children = filterNavigation(item.children, can, options);
      const hasAccess = !item.permission || can(item.permission);
      if (!hasAccess && !children.length) return acc;
      acc.push({ ...item, children });
      return acc;
    }

    if (item.permission && !can(item.permission)) return acc;
    acc.push(item);
    return acc;
  }, []);
}

export function flattenNavigation(items = []) {
  return items.flatMap((item) => [item, ...(item.children ? flattenNavigation(item.children) : [])]);
}

export function findNavigationItem(pathname, items = []) {
  for (const item of items) {
    if (item.children?.length) {
      const childMatch = findNavigationItem(pathname, item.children);
      if (childMatch) return childMatch;
    }

    if (!item.path) continue;
    if (item.end) {
      if (pathname === item.path) return item;
      continue;
    }

    if (pathname === item.path || pathname.startsWith(`${item.path}/`)) return item;
  }

  return null;
}

export function navigationItemIsActive(item, pathname) {
  if (!item?.path) return false;
  if (item.children?.length) {
    return pathname === item.path || pathname.startsWith(`${item.path}/`) || item.children.some((child) => navigationItemIsActive(child, pathname));
  }

  if (item.end) return pathname === item.path;
  return pathname === item.path || pathname.startsWith(`${item.path}/`);
}

export const navigationIcons = {
  chevronDown: ChevronDown,
  chevronRight: ChevronRight,
  graduationCap: GraduationCap,
  mail: Mail,
};
